import { OptimisticPatch } from '../CollectionOptimisticPatch';

export const transformItemByUpdateAllPatches =
  <T>(patches: OptimisticPatch<T>[]) =>
  (item: T) => {
    return patches.reduce<T>((current, { selector, patch, actionType }) => {
      if (!selector(item) || actionType !== 'updateAll') {
        return current;
      }
      return {
        ...item,
        ...patch(item),
      };
    }, item);
  };
